<template>
  <div
    class="pinwall__audio"
    v-observe-visibility="
      view === 'list' && post.audio
        ? {
            callback: visibilityChanged,
            throttle: 1500,
            intersection: {
              threshold: 0,
              rootMargin: '-50% 0% -50% 0%'
            }
          }
        : false
    "
  >
    <button v-if="!post.playMedia" @click="play" class="play-button">
      <i class="play-icon material-icons-round">play_arrow</i>
    </button>
    <PostImage
      :ref="`postImage-${post.id}`"
      :proportion="post.proportion"
      :image="image"
    />
    <AvLine
      :canv-width="canvWidth"
      class="animation"
      v-if="showAninmation && post.playMedia"
      line-color="#ffffff"
      :ref-link="`player-${post.id}`"
    />
    <audio
      :ref="`player-${post.id}`"
      @ended="ended"
      v-if="post.playMedia"
      :src="post.audio.source"
      controls
      :autoplay="autoplay"
      :muted="muted"
      :loop="playingMode === 'replay'"
      playsinline
    />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { checkIfSafari, checkIfiOsDevice } from "../../utils/helpers";
import PostImage from "../pinwall/PostImage";
import AvLine from "vue-audio-visual/src/components/AvLine";

export default {
  name: "Video",
  props: {
    post: {
      type: Object
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    muted: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      canvWidth: 0,
      showAninmation: true,
      image: {
        source: `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/cdn/assets/44d780f488f06bcfe792c889-audio.png`
      }
    };
  },
  created() {
    if (checkIfSafari() || checkIfiOsDevice(navigator.userAgent)) {
      this.showAninmation = false;
    }
  },
  computed: {
    ...mapGetters(["userClickedOnMedia", "playingPost", "playingMode"])
  },
  components: {
    PostImage,
    AvLine
  },
  methods: {
    ...mapMutations(["setUserClickedOnMedia", "setPlayingPost"]),
    ended() {
      if (this.playingMode === "playlist-play") {
        this.$emit("ended");
      }
    },
    visibilityChanged(isVisible) {
      if (this.view && this.view === "list") {
        if (this.post.audio) {
          if (isVisible && this.userClickedOnMedia) {
            this.play();
          } else {
            this.post.playMedia = false;
          }
        }
      }
    },
    play() {
      this.post.playMedia = true;
      this.canvWidth = this.$refs[`postImage-${this.post.id}`].$el.clientWidth;
      if (!this.userClickedOnMedia) {
        this.setUserClickedOnMedia(true);
      }
      this.setPlayingPost(this.post);
    }
  }
};
</script>
